export const enum LogicalOperator {
  AND = 'and',
  OR = 'or',
}

export const LogicalOperatorNameMap = new Map<string, string>([
  [LogicalOperator.AND, 'AND'],
  [LogicalOperator.OR, 'OR'],
]);
